if (process.env.NODE_ENV === 'production') {
    module.exports = require('./Store.prod');
} else {
    module.exports = require('./Store.dev');
}



// WEBPACK FOOTER //
// ./js/sport-betting/Store.js